"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./createStore"));
var createStore_1 = require("./createStore");
exports.default = createStore_1.createStore;
//# sourceMappingURL=index.js.map